module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMDAwMDggMS4xNjY1TDguNDAwMDggNS41OTk4NEwxMi44MzM0IDYuOTk5ODRMOC40MDAwOCA4LjM5OTg0TDcuMDAwMDggMTIuODMzMkw1LjYwMDA4IDguMzk5ODRMMS4xNjY3NSA2Ljk5OTg0TDUuNjAwMDggNS41OTk4NEw3LjAwMDA4IDEuMTY2NVYxLjE2NjUiIGZpbGw9IiMwMDUxREYiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/fourPointedStar.svg
// module id = 1KPd
// module chunks = 1